import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const getTheme = () => (document.documentElement.classList.contains("light") ? "light" : "dark");

export function ThemeToggle({ className = "" }) {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    const sync = () => setTheme(getTheme());
    window.addEventListener("rg2k-theme", sync);
    return () => window.removeEventListener("rg2k-theme", sync);
  }, []);
  useEffect(() => {
    if (getTheme() === theme) return;
    document.documentElement.classList.toggle("light", theme === "light");
    localStorage.setItem("rg2k_theme", theme);
    window.dispatchEvent(new Event("rg2k-theme"));
  }, [theme]);
  const light = theme === "light";
  return (
    <button onClick={() => setTheme(light ? "dark" : "light")} className={`p-2 rounded-lg hover:bg-white/5 ${className}`}
      title={light ? "Switch to dark mode" : "Switch to light mode"} aria-label="Toggle theme" data-testid="theme-toggle-btn">
      {light ? <Moon className="w-5 h-5 text-slate-200" /> : <Sun className="w-5 h-5 text-slate-200" />}
    </button>
  );
}
